<template>
    <div>
        <b-button
            v-if="user_permissions.includes('create.order.templates')"
            @click="addItem"
            >Add Item</b-button
        >
        <b-modal
            v-model="itemModal"
            id="item-modal"
            :title="(model.id || model.index ? 'Edit' : 'Add') + ' Item'"
            @ok="saveTemplateItem"
        >
            <b-form bg-variant="light">
                <b-form-row
                    class="mb-4"
                    v-if="
                        !model.id &&
                        user_permissions.includes('view.order.templates')
                    "
                >
                    <b-col cols="4">
                        <label class="font-weight-bold pt-0"
                            >Search Item:</label
                        >
                    </b-col>
                    <b-col>
                        <vue-typeahead-bootstrap
                            v-model="searchMasterItem"
                            :data="masterItems"
                            :serializer="
                                s =>
                                    s.name +
                                    ', ' +
                                    s.description +
                                    ', ' +
                                    s.type.name
                            "
                            @hit="getMasterItem"
                            @input="lookupMasterItems"
                            placeholder="Search Master Item..."
                        />
                    </b-col>
                </b-form-row>

                <div v-if="masterItemFields.length > 0">
                    <h6>Master Item</h6>
                    <b-form-row
                        v-for="(x, i) in masterItemFields"
                        :key="i + 'master-item---'"
                    >
                        <b-col cols="4"
                            ><label class="font-weight-bold pt-0"
                                >{{ x.key }}:</label
                            ></b-col
                        >{{ x.value }}<b-col></b-col>
                    </b-form-row>
                    <hr />
                    <b-form-group
                        id="default_quantity-group"
                        label="Default Quantity:"
                        label-for="input-default_quantity"
                        label-cols="4"
                        label-class="font-weight-bold pt-0"
                    >
                        <b-form-input
                            type="number"
                            id="input-default_quantity"
                            v-model="model.default_quantity"
                            required
                            placeholder="Enter Default Quantity"
                            trim
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template #modal-footer="{ ok, cancel }">
                <b-button
                    :disabled="masterItemFields.length === 0 || !modelChanged"
                    size="sm"
                    variant="success"
                    @click="ok()"
                >
                    {{
                        `${
                            !!model.index || !!model.id ? 'Update' : 'Create'
                        } Item`
                    }}
                </b-button>
                <b-button
                    v-if="hasPermissionDelete"
                    size="sm"
                    variant="danger"
                    @click="deleteTemplateItem()"
                >
                    Delete
                </b-button>
                <b-button size="sm" variant="warning" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <b-table striped hover :items="items" :fields="itemFields">
            <template #cell(id)="row">
                <b-button
                    size="sm"
                    v-if="hasPermissionView"
                    @click="viewItem(row.item.id || row.item.index)"
                    class="mr-2"
                    variant="primary"
                >
                    Select
                </b-button>
            </template>
        </b-table>
    </div>
</template>
<script>
import VueTypeaheadBootstrap from '@/components/VueTypeAhead/VueTypeaheadBootstrap'
import { debounce } from 'lodash'
import permissionsMixins from '@/mixins/permissionsMixins'

import { capitalCase } from 'change-case'
const itemFields = [
    'ext_reference_code',
    'name',
    'description',
    'uom',
    'selling_price',
    'active',
    'vendor_id',
    'order_item_type_id',
]
export default {
    name: 'OrderTemplates-templateitems',
    props: ['isSecondaryOrderType'],
    mixins: [permissionsMixins],
    components: { VueTypeaheadBootstrap },
    data() {
        return {
            searchMasterItem: '',
            itemFields: [
                {
                    key: 'id',
                    label: '',
                },
                {
                    key: 'master_item_id',
                    label: 'Name',
                    formatter: (value, key, item) => item.master_item.name,
                },
                {
                    key: 'ext_reference_code',
                    label: 'Code',
                    formatter: (value, key, item) =>
                        item.master_item.ext_reference_code,
                },
                {
                    key: 'default_quantity',
                    label: 'Qty',
                },
                {
                    key: 'uom',
                    label: 'UOM',
                    formatter: (value, key, item) => item.master_item.uom,
                },
                {
                    key: 'selling_price',
                    label: 'Price',
                    formatter: (value, key, item) =>
                        item.master_item.selling_price,
                },
                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.master_item.type.name,
                },
            ],
            model: {},
            loading: false,
            itemModal: false,
            masterItemFields: [],
            modelChanged: false,
        }
    },
    computed: {
        masterItems() {
            return this.$store.state.masterItem.items
        },
        masterItem() {
            return this.$store.state.masterItem.item
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },

        template() {
            return this.$store.state.orderTemplate.selectedTemplate
        },

        items() {
            const { isSecondaryOrderType, template } = this
            return (template.items || []).filter(
                x => x.is_secondary_order_type == isSecondaryOrderType
            )
        },
    },
    watch: {
        'model.default_quantity': function (to, from) {
            if (from >= 0) this.modelChanged = true
        },
    },
    mounted() {
        console.log('masterItems', this.masterItems)
    },
    methods: {
        lookupMasterItems: debounce(function () {
            // in practice this action should be debounced
            const query = this.searchMasterItem
            const page = 1
            const filters = {
                is_product_only: this.isSecondaryOrderType ? 1 : 0,
            }
            this.$store.dispatch('masterItem/fetch', {
                query,
                page,
                filters,
            })
        }, 500),

        getMasterItem(item) {
            //make array empty
            this.masterItemFields.splice(0)
            console.log('masterItemFields--item', item)
            if (!item) return
            this.searchMasterItem = null
            this.modelChanged = !this.model.id
            this.model.master_item_id = item.id
            // add the master item information to the model
            this.model.master_item = { ...item }
            for (let x of itemFields) {
                let key, value
                switch (x) {
                    case 'vendor_id': {
                        key = 'Vendor'
                        value = item.vendor && item.vendor.name
                        break
                    }
                    case 'order_item_type_id': {
                        key = 'Type'
                        value = item.type && item.type.name
                        break
                    }
                    case 'ext_reference_code': {
                        key = 'Code'
                        value = item[x]
                        break
                    }
                    case 'active': {
                        key = 'Active'
                        value = !!item[x]
                        break
                    }
                    default: {
                        key = capitalCase(x)
                        value = item[x]
                    }
                }
                this.masterItemFields.push({ key, value })
            }
        },
        addItem() {
            this.masterItemFields.splice(0)
            this.model = {
                id: null,
                default_quantity: null,
                master_item_id: null,
            }
            this.itemModal = true
        },
        async viewItem(templateId) {
            /* if the template exists find the item among the template's 
            items otherwise, firnd the item among the template model's items */
            const templateItem =
                this.template.items.find(x => x.id === templateId) || {}

            const { master_item_id } = templateItem

            this.model = { ...templateItem }

            if (this.template.id) {
                await this.$store.dispatch(
                    'masterItem/fetchById',
                    master_item_id
                )
                await this.$nextTick()
                this.getMasterItem(this.masterItem)
            } else {
                this.getMasterItem(templateItem.master_item)
            }
            this.itemModal = true
        },
        deleteTemplateItem() {
            this.loading = true
            // if the template exists delete the master item from the database
            if (this.template.id) {
                const path = `orderTemplate/deleteItem`
                const template_id = this.template.id
                const item_id = this.model.id
                this.$store
                    .dispatch(path, { template_id, item_id })
                    .then(() => {
                        this.loading = false
                        this.itemModal = false
                        this.modelChanged = false
                    })
                    .catch(error => {
                        console.log('error', error)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                // if this is a new template, delete the master item from the template moel
                this.template_model.items.splice(this.model.index - 1, 1)

                // reindex the items
                for (var i = 1; i <= this.template_model.items.length; i++) {
                    this.template_model.items[i - 1].index = i
                }
                this.loading = false
                this.itemModal = false
                this.modelChanged = false
            }
        },
        saveTemplateItem(bvModalEvt) {
            bvModalEvt.preventDefault()
            const { isSecondaryOrderType: is_secondary_order_type } = this
            const item = { ...this.model, is_secondary_order_type }
            item.default_quantity = item.default_quantity || 0
            const template_id = this.template.id
            const model = { template_id, item }

            if (this.template.id) {
                // if the template exists add the master item to the template in the database or update it in the database
                const path = `orderTemplate/${
                    parseInt(item.id) ? 'updateItem' : 'createItem'
                }`

                this.loading = true
                this.$store
                    .dispatch(path, model)
                    .then(() => {
                        this.loading = false
                        this.itemModal = false
                        this.modelChanged = false
                    })
                    .catch(error => {
                        console.log('error', error)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                // if the template does not exist add the master item to or update it in the template model's item list
                if (model.item.should_update) {
                    this.loading = true
                    model.item.should_update = true

                    this.template_model.items.splice(
                        model.item.index - 1,
                        1,
                        model.item
                    )
                    this.itemModal = false
                    this.modelChanged = false
                    this.loading = false
                } else {
                    this.loading = true
                    model.item.should_update = true
                    var index = this.template_model.items.push(model.item)

                    this.template_model.items[index - 1].index = index

                    this.itemModal = false
                    this.modelChanged = false
                    this.loading = false
                }
            }
        },
    },
}
</script>
